export const MY_FINANCE_LINKS = [
  {
    backgroundPosition: '0 0',
    location: 'http://usetri.aktualne.cz/hypoteky/srovnani/',
    text: 'Spočítejte si nejvýhodnější hypotéku',
    utmContent: 'hypoteka'
  },
  {
    backgroundPosition: '0 -34px',
    location: 'http://usetri.aktualne.cz/cestovni-pojisteni/srovnani/',
    text: 'Cestovní pojištění za hubičku',
    utmContent: 'cestovni-pojisteni'
  },
  {
    backgroundPosition: '0 -67px',
    location: 'http://usetri.aktualne.cz/povinne-ruceni/srovnani/',
    text: 'Povinné ručení na míru za výhodnou cenu',
    utmContent: 'povinne-ruceni'
  },
  {
    backgroundPosition: '0 -138px',
    location: 'https://zpravy.aktualne.cz/finance/kalkulacka-vypocet-mzdy/r~492700f4688411e892700cc47ab5f122/',
    text: 'Výpočet čisté mzdy v roce 2018',
    utmContent: 'cista-mzda'
  }
]
